
namespace RedBullMOBILE360.Administration {

    @Serenity.Decorators.registerClass()
    export class DbLinkMapDialog extends Serenity.EntityDialog<DbLinkMapRow, any> {
        protected getFormKey() { return DbLinkMapForm.formKey; }
        protected getIdProperty() { return DbLinkMapRow.idProperty; }
        protected getLocalTextPrefix() { return DbLinkMapRow.localTextPrefix; }
        protected getNameProperty() { return DbLinkMapRow.nameProperty; }
        protected getService() { return DbLinkMapService.baseUrl; }
        protected getDeletePermission() { return DbLinkMapRow.deletePermission; }
        protected getInsertPermission() { return DbLinkMapRow.insertPermission; }
        protected getUpdatePermission() { return DbLinkMapRow.updatePermission; }

        protected form = new DbLinkMapForm(this.idPrefix);

    }
}